import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ICaseInput } from '../../../models/case.interface';
import { CaseApiService } from '../../../services/data/case-api.service';


@Component({
  selector: 'ebb-contact-us',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss']
})
export class ContactUsComponent implements OnInit {
  public iCaseInput: ICaseInput = {} as ICaseInput;
  public formAutoSave = false;
  public contactUsInput: FormGroup;
  public messageSent = false;
  public sendError = '';

  @Input() set name (value: string) {
    if ( value ){
      const name = this.contactUsInput.get('name');
      name.setValue(value);
    }
  }
  
  @Input() set email (value: string) {
    if ( value ){
      const emailField = this.contactUsInput.get('emailAddress');
      emailField.setValue(value);
      emailField.disable();
    }
  }

  constructor(
    private _fb: FormBuilder,
    private apiCase: CaseApiService
  ) {
    this.contactUsInput = this._fb.group(
      {
        name: [null, [Validators.required, Validators.maxLength(100)]],
        emailAddress: ['', [Validators.required, Validators.email]],
        contactReason: [null, Validators.required],
        message: [null, [Validators.required, Validators.maxLength(2000)]],
      }
    );
  }

  public ngOnInit(): void {
  }


  public onSave() {
    this.formAutoSave = true;
    this.iCaseInput.emailAddress = this.contactUsInput.get('emailAddress').value;
    this.iCaseInput.description = this.contactUsInput.get('message').value;
    this.iCaseInput.title = this.contactUsInput.get('contactReason').value;

    this.sendError = '';
    let program = 'FEMA|EBB';
    if (window['program']) {
      program = window['program'];
    }

    const name = this.contactUsInput.get('name').value;

    if (this.iCaseInput.emailAddress) {
      this.apiCase.saveCase(this.iCaseInput, program, name).subscribe(
        data => {
          if (data) {
            this.formAutoSave = false;
            this.messageSent = true;
          }
        },
        error => {
          if(error.graphQLErrors[0]){
            this.sendError = error.graphQLErrors[0].message;
          } else {
            this.sendError = 'Error saving data';
          }
          this.formAutoSave = false;
          console.warn(`ERROR: saveCase() - ${error}`);
        }
      );
    }
  }
}
